const React = require('react')
const PropTypes = require('prop-types')
const classNames = require('classnames')
const { sendProEvent } = require('lib/analytics_pro')
const PortfolioThumb = require('./portfolio_thumb')
const Portfolio = require('component/portfolio/portfolio')
const hasFeature = require('module/user/helpers/has_feature')
const isAllowedFeature = require('module/user/helpers/is_allowed_feature')
const Layer = require('component/layer')
const log = require('log').create('portfolio') // eslint-disable-line

const MAX_THUMBS = 5

function sortByOrder(a, b) {
    return a.order - b.order
}

class PortfolioSection extends React.Component {

    constructor() {
        super()

        this.state = {
            show_layer: false,
        }

        this.showLayer = this.showLayer.bind(this)
        this.hideLayer = this.hideLayer.bind(this)
    }

    componentDidMount() {
        // for testing, show portfolio immediately
        // this.showLayer()
    }

    showLayer() {
        this.setState({
            show_layer: true,
        })

        sendProEvent('Portfolio', 'viewed')
    }
    hideLayer() {
        this.setState({
            show_layer: false,
        })
    }

    render() {
        const { user } = this.props

        // don't render if user is not allowed this feature
        // e.g. an expired pro user
        // features list still calls this 'gallery'
        if (! isAllowedFeature(user, 'gallery')) return null

        // don't render if user has not added this feature
        if (! hasFeature(user, 'portfolio')) return null

        const { show_layer } = this.state

        const items = user.portfolio.filter(item => !! item.url) // .slice(0, 4)
        items.sort(sortByOrder)

        const thumbs_classname = classNames([
            'portfolio-thumbs',
        ], {
            'more-than-5': items.length > 5,
        })

        return (
            <section className="portfolio inset">
                <ul className={thumbs_classname}>
                    {
                        items
                            .slice(0, MAX_THUMBS)
                            .map((item, i) => {
                                return (
                                <PortfolioThumb
                                    key={i}
                                    item={item}
                                    onClick={() => this.showLayer()}
                                    />
                                )
                            })
                    }
                </ul>
                {show_layer && (
                    <Layer>
                        <Portfolio user={user} close={this.hideLayer} />
                    </Layer>
                )}
            </section>
        )
    }
}

PortfolioSection.propTypes = {
    user: PropTypes.shape({
        portfolio: PropTypes.array,
    }).isRequired,
}

module.exports = PortfolioSection
